/**
 * QR-код для гостевого входа — тонкая типизированная обёртка над вендоренным
 * генератором (Kazuhiko Arase, MIT, см. qrcode-vendor.generated.ts).
 *
 * Вендорим, а не тянем npm-пакет, чтобы не регенерировать pnpm-lock на
 * сборочном хосте (риск для build-гейта). Возвращаем матрицу boolean[][]
 * (true = тёмный модуль); рендер в <svg> делает QrCanvas.
 *
 * Проверено: deep-link Telegram-бота (ASCII) кодируется в версию ≤4 и
 * декодируется обратно 1:1 (jsQR) — код сканируется.
 */
import { generateQrMatrix as vendorGenerate } from './qrcode-vendor.generated.js';

/** Матрица модулей QR (true = тёмный) для строки `text`. */
export function generateQrMatrix(text: string): boolean[][] {
  return vendorGenerate(text) as boolean[][];
}
